import { __rest } from "tslib";
import clsx from 'clsx';
import React from 'react';
export default function BaseType(_a) {
    var { baseClass, className, bold = false, fade = false, noTopSpacer = false, Component = 'div' } = _a, otherProps = __rest(_a, ["baseClass", "className", "bold", "fade", "noTopSpacer", "Component"]);
    return (React.createElement(Component, Object.assign({ className: clsx(baseClass, className, bold && 'kal-type-bold', fade && 'kal-type-fade', noTopSpacer && 'kal-no-top-spacer') }, otherProps)));
}
//# sourceMappingURL=BaseType.js.map